import { SageClassnames, Frame, Link } from '@kajabi/sage-react';
import React from 'react';

export const LoginSection = () => (
  <Frame
    direction={Frame.DIRECTIONS.HORIZONTAL}
    align={Frame.ALIGNMENTS.CENTER_CENTER}
    gap={Frame.GAPS.XS}
  >
    <p
      className={[
        SageClassnames.TYPE.BODY_SEMI,
        SageClassnames.TYPE_COLORS.CHARCOAL_400,
      ].join(' ')}
    >
      Already have an account?
    </p>

    <Link style={Link.COLORS.SECONDARY} href="https://app.kajabi.com">Log in here</Link>
  </Frame>
);
